import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/userContext";


export default function PropertyAddressProp(props) {
    const { mainClassName, roomClassName, addressClassName, property, isProperty } = props;
    const {isMobile} = useContext(UserContext);



    const navigate = useNavigate();

    // Handle card click
    const handleCardClick = ()=>{
        navigate(`/properties/property/${property._id}`);

    }
    

    return (
        <div 
            className={mainClassName} 
            onClick={isProperty ? null : handleCardClick} 
        >
            <p className={roomClassName}>
                <span className="roomDetail room">{property.rooms} beds</span>
                <span className="roomDetail room">{property.bathrooms} bath</span>
                <span className="roomDetail">{property.receptions} receptions</span>
            </p>
            <span className={addressClassName}>{property.address}</span>
            {isMobile && <span className="scroll">Scroll down to place a bid!</span>}
        </div>
    );
}
